<section id="gallery">
    <h2 class="animate__animated animate__fadeIn">Galería</h2>
    <div class="gallery-container">
      <!-- Botón Izquierda -->
      <button class="gallery-btn left" (click)="scrollLeft()">&#10094;</button>

        <div class="gallery-scroll" #galleryScroll>
            <img src="assets/img/gallery/Imagen1.jpg" alt="Imagen 1" class="gallery-img" (click)="openLightbox('assets/img/gallery/Imagen1.jpg')">
            <img src="assets/img/gallery/Imagen2.jpg" alt="Imagen 2" class="gallery-img" (click)="openLightbox('assets/img/gallery/Imagen2.jpg')">
            <img src="assets/img/gallery/Imagen3.jpg" alt="Imagen 3" class="gallery-img" (click)="openLightbox('assets/img/gallery/Imagen3.jpg')">
            <img src="assets/img/gallery/Imagen4.jpg" alt="Imagen 4" class="gallery-img" (click)="openLightbox('assets/img/gallery/Imagen4.jpg')">
            <img src="assets/img/gallery/Imagen5.jpg" alt="Imagen 5" class="gallery-img" (click)="openLightbox('assets/img/gallery/Imagen5.jpg')">
            <img src="assets/img/gallery/Imagen6.jpg" alt="Imagen 6" class="gallery-img" (click)="openLightbox('assets/img/gallery/Imagen6.jpg')">
            <img src="assets/img/gallery/Imagen7.jpg" alt="Imagen 7" class="gallery-img" (click)="openLightbox('assets/img/gallery/Imagen7.jpg')">
           
            <!-- Agregar más imágenes aquí -->
        </div>
        <!-- Botón Derecha -->  
    <button class="gallery-btn right" (click)="scrollRight()">&#10095;</button>
</div>
</section>

<!-- Lightbox para ver la imagen en grande -->
<div id="lightbox" class="lightbox" [class.active]="lightboxOpen">
    <span class="close-lightbox" (click)="closeLightbox()">&times;</span>
    <img class="lightbox-img" [src]="lightboxImage">
</div>